
<section #location class="location">
    <div class="map-wrapper"
        [class.show-route-1]="route == '1'"
        [class.show-route-2]="route == '2'"
        [class.show-route-3]="route == '3'"
        [class.show-route-4]="route == '4'"
        [class.show-route-5]="route == '5'"
        [class.show-route-6]="route == '6'"
        [class.show-route-7]="route == '7'"
        [class.show-route-8]="route == '8'"
        [class.show-route-9]="route == '9'"
        >
        <div class="text" [style.top]="((1 - offset) * 40) + 'rem'">
            <h2 class="f-upper f-light f-right" [class.dencapsulate]="animate" [innerHTML]="encapsulate(content[language].menu.location)"></h2>
            <h3 class="f-upper f-light f-right" [class.dencapsulate]="animate" [innerHTML]="encapsulate(content[language].location.title)"></h3>
            <p class="f-light f-right" [class.animate]="animate" [innerHTML]="content[language].location.text"></p>
        </div>
        
        <div class="trigger trigger-1" (mouseenter)="route = '1'" (mouseleave)="route = '0'" (click)="route = '1'"></div>
        <div class="trigger trigger-2" (mouseenter)="route = '2'" (mouseleave)="route = '0'" (click)="route = '2'"></div>
        <div class="trigger trigger-3" (mouseenter)="route = '3'" (mouseleave)="route = '0'" (click)="route = '3'"></div>
        <div class="trigger trigger-4" (mouseenter)="route = '4'" (mouseleave)="route = '0'" (click)="route = '4'"></div>
        <div class="trigger trigger-5" (mouseenter)="route = '5'" (mouseleave)="route = '0'" (click)="route = '5'"></div>
        <div class="trigger trigger-6" (mouseenter)="route = '6'" (mouseleave)="route = '0'" (click)="route = '6'"></div>
        <div class="trigger trigger-7" (mouseenter)="route = '7'" (mouseleave)="route = '0'" (click)="route = '7'"></div>
        <div class="trigger trigger-8" (mouseenter)="route = '8'" (mouseleave)="route = '0'" (click)="route = '8'"></div>
        <div class="trigger trigger-9" (mouseenter)="route = '9'" (mouseleave)="route = '0'" (click)="route = '9'"></div>

        <!-- pins e routes -->
        <div class="pin route route-1"><img src="assets/images/map-route-1.png"></div>
        <img class="pin pin-1" src="assets/images/map-pin-1.png">

        <div class="pin route route-2"><img src="assets/images/map-route-2.png"></div>
        <img class="pin pin-2" src="assets/images/map-pin-2.png">

        <div class="pin route route-3"><img src="assets/images/map-route-3.png"></div>
        <img class="pin pin-3" src="assets/images/map-pin-3.png">

        <div class="pin route route-4"><img src="assets/images/map-route-4.png"></div>
        <img class="pin pin-4" src="assets/images/map-pin-4.png">

        <div class="pin route route-5"><img src="assets/images/map-route-5.png"></div>
        <img class="pin pin-5" src="assets/images/map-pin-5.png">

        <div class="pin route route-6"><img src="assets/images/map-route-6.png"></div>
        <img class="pin pin-6" src="assets/images/map-pin-6.png">

        <div class="pin route route-7"><img src="assets/images/map-route-7.png"></div>
        <img class="pin pin-7" src="assets/images/map-pin-7.png">

        <div class="pin route route-8"><img src="assets/images/map-route-8.png"></div>
        <img class="pin pin-8" src="assets/images/map-pin-8.png">

        <div class="pin route route-9"><img src="assets/images/map-route-9.png"></div>
        <img class="pin pin-9" src="assets/images/map-pin-9.png">

        <img class="map" src="assets/images/map.jpg">

        <div class="d-flex">
            <div class="walk" [style.top]="((1 - offset) * 20) + 'rem'">
                <h4 class="f-upper f-center d-flex align-center justify-center"><img src="assets/images/buddy.svg">walking distance<!-- todo --></h4>
                <ul class="d-flex align-top wrap">
                    <li class="d-flex align-center" *ngFor="let i of content[language].location.walk; let index = index" (click)="route = (index + 1) + ''"><span>{{ index + 1 }}</span>{{ i }}</li>
                </ul>
            </div>
            <div class="drive" [style.top]="((1 - offset) * 20) + 'rem'">
                <h4 class="f-upper f-center d-flex align-center justify-center"><img src="assets/images/car.svg">Drive<!-- todo --></h4>
                <ul class="d-flex align-top wrap">
                    <li class="d-flex align-center" *ngFor="let i of content[language].location.drive; let index = index"><span>{{ index + 1 }}</span>{{ i }}</li>
                </ul>
            </div>
        </div>
    </div>
</section>